module.exports = __webpack_public_path__ + "img/home.adb4c206.jpg";